var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPaymentMethodMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20264,
    y: 3.84766,
    width: 21,
    height: 14.3043,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9076 14.5367C11.0682 15.241 9.97928 15.6661 8.78941 15.6661C6.13445 15.6661 3.98218 13.5493 3.98218 10.9382C3.98218 8.32698 6.13445 6.21021 8.78941 6.21021C9.97929 6.21021 11.0682 6.63537 11.9076 7.33966C12.7471 6.63538 13.836 6.21022 15.0258 6.21022C17.6808 6.21022 19.8331 8.327 19.8331 10.9382C19.8331 13.5494 17.6808 15.6661 15.0258 15.6661C13.836 15.6661 12.7471 15.241 11.9076 14.5367Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9077 14.5367C12.9413 13.6695 13.5967 12.3791 13.5967 10.9382C13.5967 9.49722 12.9413 8.20684 11.9077 7.33965C12.7472 6.63537 13.8361 6.21021 15.0259 6.21021C17.6809 6.21021 19.8332 8.32698 19.8332 10.9382C19.8332 13.5493 17.6809 15.6661 15.0259 15.6661C13.8361 15.6661 12.7472 15.241 11.9077 14.5367Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9078 14.5366C12.9414 13.6694 13.5968 12.379 13.5968 10.9381C13.5968 9.49717 12.9414 8.20679 11.9078 7.3396C10.8741 8.20679 10.2188 9.49717 10.2188 10.9381C10.2188 12.379 10.8742 13.6694 11.9078 14.5366Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMethodMastercard);
export default __webpack_public_path__ + "static/media/icon_payment_method_mastercard.318d84e00d64be86896fc11037ea0f8c.svg";
export { ForwardRef as ReactComponent };